<template>
  <div style="width: 100%; padding: 0 8px">
    <div v-if="loading">
      <a-skeleton :loading="loading" active :paragraph="{ rows: 1 }" />
      <a-skeleton :loading="loading" active :paragraph="{ rows: 1 }" />
      <a-skeleton :loading="loading" active :paragraph="{ rows: 1 }" />
    </div>

    <a-list v-else item-layout="vertical" :data-source="dataSource">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta>
          <span slot="title">
            <span>{{ item.name }}</span>
            <a class="custom-link" @click="onEdit(item)">编辑</a>
          </span>
        </a-list-item-meta>
        <div class="list-content">
          <a-steps class="template-card-steps" size="small" :current="null" :style="{ width: `${item.steps.length * 140}px` }">
            <a-step v-for="step in item.steps" :key="step.id" :title="step.name" />
          </a-steps>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import { workflowTemplateList } from '@/api/project/workflow';

export default {
  data() {
    return {
      loading: true,
      dataSource: [],
      filterForm: {
        status: null
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 20, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  mounted() {
    this.getWorkflowTemplateList();
  },
  methods: {
    onFilter(filter) {
      this.filterForm = filter;
      this.pagination.current = 1;
      this.getWorkflowTemplateList();
    },

    /**
     * 获取流程模板列表
     */
    getWorkflowTemplateList() {
      this.loading = true;
      workflowTemplateList({
        ...this.filterForm,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.loading = false;
          this.dataSource = res.data.items;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 点击编辑
     * @param {*} record
     */
    onEdit(record) {
      this.$router.push({
        name: 'pages:system:workflow:edit',
        query: { id: record.id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.template-card {
  width: 960px;
}
.template-card-title {
  line-height: 24px;
}
.list-content {
  overflow-x: scroll;
  height: 30px;
}
.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 8px;
}

.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 0px;
  font-weight: normal;
  a {
    float: right;
    font-size: 14px;
  }
}
</style>
